(function($) {
  // Ensure jQuery is loaded
  if (!$) {
    console.error('jQuery not loaded.');
    return;
  }

  $(document).ready(function() {
    var threshold = 1,
        $window = $(window),
        currentScroll = $window.scrollTop();

    // Function to toggle shrink class
    function toggleShrink() {
      var scrollPos = $window.scrollTop();
      if (scrollPos > threshold) {
        $("body").addClass("shrink");
      } else {
        $("body").removeClass("shrink");
      }
    }

    // Run on scroll
    $window.on('scroll', toggleShrink);

    // Run on page load in case page is refreshed mid-scroll
    toggleShrink();
  });
})(jQuery);